import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import EligibilityDetail from "./eligibility-detail";

const PatientOutreachEligibilityRoute = () => {
  const { patientGuid } = useParams();
  const history = useHistory();
  const [searchInput, setSearchInput] = useState(patientGuid || "");

  const handleSearch = e => {
    e.preventDefault();
    const trimmed = searchInput.trim();
    if (trimmed) {
      history.push(
        `/patient-call-pool/eligibility/${encodeURIComponent(trimmed)}`
      );
    }
  };

  return (
    <div className="patient-outreach-eligibility-page" style={{ padding: 24 }}>
      <h1>Patient Outreach Eligibility</h1>

      <form onSubmit={handleSearch} style={{ marginBottom: 24 }}>
        <label>
          Look up a patient by GUID:{" "}
          <input
            type="text"
            value={searchInput}
            onChange={e => setSearchInput(e.target.value)}
            placeholder="Patient GUID"
          />
        </label>
        <button type="submit">Search</button>
      </form>

      {patientGuid && <EligibilityDetail patientGuid={patientGuid} />}
    </div>
  );
};

export default PatientOutreachEligibilityRoute;
